import { Component, Input } from "@angular/core";
import { ServiceControllerStatusEnum, WindowsService } from "../../../../models/windows-service";
import { SharedActions } from "../../../../shared.actions";

@Component({
  selector: "services-header",
  templateUrl: "./services-header.component.html",
  styleUrls: ["./services-header.component.scss"]
})
export class ServicesHeaderComponent {

  @Input() monitoringService: WindowsService;

  monitoringStatuses = ServiceControllerStatusEnum;

  constructor(
    private sharedActions: SharedActions
  ) {
  }

  public checkForMonitorService() {
    this.sharedActions.getMonitorServiceStatus();
  }
}
